module.exports = require("@agm/core/utils/browser-globals");